export default __webpack_public_path__ + "static/media/recreation-LP.158bd943.svg";